import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Loader } from '@dataplace.ai/ui-components/atoms'
import { useAppDispatch } from 'apps/placeme/src/redux/hooks'
import { useSelector } from 'react-redux'
import { RootState } from 'apps/placeme/src/redux/store'
import { AuthContext } from '@dataplace.ai/features'
import { useFetchTileData } from 'apps/placeme/src/customHooks/useFetchTileData'

import { AlabAttractivenessFormDataObject, FormFieldValue, IAlabAttractivenessTileBody, IAlabAttractivenessTileData } from './@types/IAlabAttractivenessTileData'
import { AlabAttractivenessResult } from './AlabAttractivenessResult'
import { deleteTileAction, saveChosenRangeAction } from '../../../../slice/analysisSlice'
import { AlabAttractivenessForm } from './AlabAttractivenessForm'

interface IAlabAttractivenessTileProps {
  data: IAlabAttractivenessTileData
  tileId: string
  body: IAlabAttractivenessTileBody | null
  categoryId: string
  endpoint: string
  areAllFieldsFilled: boolean
  setFormValue: (key: string, value: FormFieldValue) => void
  formDataObject: AlabAttractivenessFormDataObject
}

export const AlabAttractivenessTile: React.FC<IAlabAttractivenessTileProps> = ({
  data,
  endpoint,
  tileId,
  body,
  categoryId,
  formDataObject,
  setFormValue,
  areAllFieldsFilled,
}) => {
  const authContext = useContext(AuthContext)
  const dispatch = useAppDispatch()
  const { analyseId } = useSelector((state: RootState) => state.location)

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [token, setToken] = useState('')

  const { fetchData } = useFetchTileData(
    data,
    endpoint,
    tileId,
    categoryId,
    body,
    setIsSubmitting,
    true,
  )

  const handleSubmit = () => {
    if (isSubmitting) return

    setAccepted(true)
    setIsSubmitting(true)
    fetchData()
  }

  const handleDeleteTile = useCallback(() => {
    if (!token) return
    dispatch(deleteTileAction(token, categoryId, tileId, analyseId || ''))
  }, [dispatch, token, categoryId, tileId, analyseId])

  useEffect(() => {
    authContext?.userData?.user?.getIdToken()?.then((response) => {
      setToken(response)
    })
  }, [authContext])

  useEffect(() => {
    if (!data?.value?.attractiveness?.catchmentId) return

    dispatch(saveChosenRangeAction(categoryId, tileId, {
      id: '',
      value: 0,
      type: 'line',
      catchmentId: data?.value?.attractiveness.catchmentId || '',
    }))
  }, [data?.value?.attractiveness?.catchmentId])

  if (isSubmitting && (data?.loading || !data?.value)) return <Loader />

  return (
    (!accepted && !isSubmitting) && !data?.value
      ? (
        <AlabAttractivenessForm
          areAllFieldsFilled={areAllFieldsFilled}
          formDataObject={formDataObject}
          handleDeleteTile={handleDeleteTile}
          handleSubmit={handleSubmit}
          setFormValue={setFormValue}
        />
      )
      : <AlabAttractivenessResult data={data} />
  )
}
